import { request } from './request';
import { URLParamBuilder } from '@/utils/functions';
import * as PATHS from '@/constants/path';
import { Message } from '@/components/Communication/types';
import { extractTextFromHtml } from '@/utils/html';

/**
 * Maps the API sent-mail response to the internal Message model
 */
export function mapSentMailToMessage(mail: any, fallbackRecipient?: string): Message {
  const from = Array.isArray(mail.from) ? mail.from[0] : mail.from;
  const sender = from ? (from.name ? `${from.name} <${from.email}>` : from.email) : (mail.sender_email || '');

  const htmlContent = mail.html || '';
  const strippedContent = extractTextFromHtml(htmlContent);

  return {
    id: String(mail.uuid || mail.id || Math.random()),
    medium: 'email',
    sender,
    recipient: Array.isArray(mail.to) ? (mail.to[0]?.email || '') : (mail.to?.email || mail.recipient_email || fallbackRecipient || ''),
    content: mail.body || mail.content || strippedContent,
    html: mail.html,
    timestamp: mail.sent_at || mail.createdAt || mail.created_at || '',
    subject: mail.subject || '',
    status: 'sent',
  };
}

export async function getProjectMessages(projectId: string, query?: any) {
  const url = URLParamBuilder(PATHS.GET_LEAD_SENT_MAILS, {
    params: { leadId: projectId },
    queryString: query,
  });
  return request(url, {
    method: 'GET',
  });
}

export async function fetchLeadSentMails(leadId: string, query?: any) {
  const url = URLParamBuilder(PATHS.GET_LEAD_SENT_MAILS, {
    params: { leadId },
    queryString: query,
  });
  return request(url, {
    method: 'GET',
  });
}
